import { render, staticRenderFns } from "./reservation-list.vue?vue&type=template&id=14bc6f20&scoped=true"
import script from "./reservation-list.vue?vue&type=script&lang=js"
export * from "./reservation-list.vue?vue&type=script&lang=js"
import style0 from "./reservation-list.vue?vue&type=style&index=0&id=14bc6f20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bc6f20",
  null
  
)

export default component.exports